@if (users().length) {
  <div class="table-width margin--bottom-l">
    <table [dataSource]="users()" mat-table>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Navn</th>
        <td mat-cell *matCellDef="let user" class="row">{{ user.firstName }} {{ user.lastName }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let user" class="row">{{ user.email }}</td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>Rolle</th>
        <td mat-cell *matCellDef="let user" class="row">{{ user.role.description }}</td>
      </ng-container>

      <ng-container matColumnDef="departments">
        <th mat-header-cell *matHeaderCellDef>Afdelinger</th>
        <td mat-cell *matCellDef="let user" class="row">
          @if (user.departmentRestrictionNames?.length === 1) {
            1 afdeling
          } @else {
            {{ user.departmentRestrictionNames?.length || 0 }} afdelinger
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let user" class="row">
          <button mat-icon-button title="Rediger bruger" (click)="editUser(user)">
            <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
      <tr mat-row *matRowDef="let user; columns: displayColumns" [class.highlight]="user.id === userBeingEdited?.id"></tr>
    </table>
  </div>
}

@if (!showForm) {
  <button mat-raised-button [color]="'secondary'" class="margin--top-s" (click)="handleAddPortalUser()">
    <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
    Tilknyt ny portalbruger
  </button>
}

@if (showForm) {
  <div [formGroup]="form" class="user-form">
    <div class="form-row">
      <mat-form-field>
        <mat-label>Navn</mat-label>
        <input matInput placeholder="Navn på brugeren" maxlength="75" formControlName="name" required value="" />
        @if (form.controls.name.invalid) {
          <mat-error>Indtast venligst navn</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input matInput placeholder="Brugerens email adresse" maxlength="100" formControlName="email" />
        @if (form.controls.email.invalid) {
          <mat-error>Indtast venligst en gyldig email adresse</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="form-row">
      <h5 class="margin--bottom-none">Rolle</h5>
      <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" formControlName="role">
        @for (role of roles$ | async; track role) {
          <mat-radio-button class="example-radio-button" [value]="role.name">{{ role.description }}</mat-radio-button>
        }
      </mat-radio-group>
    </div>

    <div class="form-row">
      <mat-form-field>
        <mat-select formControlName="departments" placeholder="Vælg afdeling" multiple okCustomDropDownArrowDirective>
          @for (department of departments(); track department.departmentId) {
            <mat-option [value]="department.departmentId">
              {{ department.departmentName }}
            </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>
  </div>

  <div class="form-row flex">
    <button mat-button (click)="resetAndHideForm()" class="margin--left-auto margin--right-m">Annuller</button>

    <button
      mat-raised-button
      [color]="'secondary'"
      [disabled]="!form.valid || addingUsers"
      [class.spinner]="addingUsers"
      (click)="submitForm()">
      @if (userBeingEdited) {
        Gem portalbruger
      } @else {
        Tilknyt portalbruger
      }
    </button>
  </div>

  @if (!userBeingEdited) {
    <div class="form-row">
      <ok-feedback-info>
        <div>
          <strong>Oprettelse af bruger</strong>
          <br />
          Efter oprettelse vil brugeren modtage en velkomst e-mail hvori brugeren får mulighed for at tilgå portalen og oprette et
          personligt kodeord
        </div>
      </ok-feedback-info>
    </div>
  }
}

<div class="form-row margin--top-xl">
  <button [routerLink]="'/organizations'" mat-raised-button color="primary">Afslut oprettelse</button>
</div>
